import { SET_DASHBOARD_LOADING, GET_DATA, GET_CONTACTS_DATA, CLEAR_CONTACTS_DATA } from './SpeedTypes'

const initialState = {
  data: {},
  isLoading: false,
  contactsData: {
    query: {},
    data: [],
  },
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_DASHBOARD_LOADING:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    case GET_DATA:
      return {
        ...state,
        data: action.payload,
        isLoading: false,
      }
    case GET_CONTACTS_DATA:
      return {
        ...state,
        contactsData: action.payload,
      }
    case CLEAR_CONTACTS_DATA:
      return initialState
    default:
      return state
  }
}
